// extracted by mini-css-extract-plugin
export default {"action":"AccountPane_action__RJtKU","actionButton":"AccountPane_actionButton__Vri0Y","wrapper":"AccountPane_wrapper__pWfwV"};